<template>
  <div :class="{ContactForm : !getMobile, ContactFormMobile : getMobile}">
    <v-form
      ref="form"
    >
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.firstName"
        :label="getText.firstName"
      ></v-text-field>
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.lastName"
        :label="getText.lastName"
      ></v-text-field>
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.email"
        :rules="emailRules"
        :label="getText.mail"
      ></v-text-field>

      <!-- <v-radio-group
        v-if="getOrder.totalPrice > 20"
        v-model="contact.expressBuild"
        class="red--text">
        <v-radio
          :label="getText.expressBuildNo"
          color="var(--accentColor)"
          value="expressBuildNo"
        ></v-radio>
        <v-radio
          :label="getText.expressBuildYes"
          color="var(--accentColor)"
          value="expressBuildYes"
        ></v-radio>
      </v-radio-group> -->

      <!-- <v-radio-group
        v-if="getOrder.totalPrice > 20"
        v-model="shippingVmodel"
        class="red--text">
        <v-radio
          :label="getText.shipping"
          color="var(--accentColor)"
          value="shipping"
        ></v-radio>
        <v-radio
          :label="shippingLabel"
          color="var(--accentColor)"
          value="pickUp"
        ></v-radio>
        <v-radio
          :label="getText.outsideGermany"
          color="var(--accentColor)"
          value="outsideGermany"
        ></v-radio>
      </v-radio-group> -->

      <!-- <p v-if="!contact.shipping" style="text-align: left; position: relative; top: -15px;">
      {{getText.pickUpAdress1}}<br/>
      {{getText.pickUpAdress2}}<br/>
      {{getText.pickUpAdress3}}
      </p> -->
      <!-- <p v-if="contact.outsideGermany" style="text-align: left; position: relative; top: -15px;">
      {{getText.outsideGermanyText}}
      </p> -->
      <!-- <v-text-field
        v-if="contact.outsideGermany"
        color="var(--accentColor)"
        v-model="contact.country"
        :label="getText.country"
      ></v-text-field> -->
      <span style="color:var(--mainColor);">{{getText.shippingText}}</span>
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.street"
        :label="getText.streetAndNumber"
      ></v-text-field>
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.zip"
        :label="getText.zip"
      ></v-text-field>
      <v-text-field
        color="var(--accentColor)"
        v-model="contact.city"
        :label="getText.city"
      ></v-text-field>
      <v-text-field
        color="var(--accentColor)"
        v-if="getOrder.totalPrice > 20"
        v-model="contact.phone"
        :label="getText.phone"
      ></v-text-field>

      <div v-if="!getVoucherAccepted && getOrder.totalPrice > 20" style="position:relative; display: grid; grid-template-columns: 1fr 105px;" >
        <div>
          <v-text-field
            color="var(--accentColor)"
            v-model="contact.voucher"
            :label="getText.voucher"
          ></v-text-field>
        </div>
        <div>
          <v-btn @click="applyVoucher()" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.applyVoucher}}</span>
          </v-btn>
        </div>
      </div>
      <div v-if="getVoucherAccepted">
        <v-card class="mx-auto card" width="100%" color="var(--accentColorShadedComplementary)" >
          <h3 style="color: var(--mainColor); text-align: left;">{{getText.voucherSubtracted1}}{{getCustomerInformation.voucherSum}}{{getText.voucherSubtracted2}}</h3>
        </v-card>
      </div>
      <div v-if="discount">
        <v-card class="mx-auto card" width="100%" color="var(--accentColorShadedComplementary)" >
          <h3 style="color: var(--mainColor); text-align: left;">{{getText.discountSubtracted1}}{{discountAmount}}{{getText.discountSubtracted2}}</h3>
        </v-card>
      </div>

      <v-textarea
          color="var(--accentColor)"
          outlined
          name="input-7-1"
          :label="getText.message"
          v-model="contact.message"
        ></v-textarea>

        <v-checkbox
          v-model="contact.datasecurity"
          :label="getText.datasecurity"
          color="var(--accentColor)"
          >
        </v-checkbox>

    </v-form>
  </div>
</template>

<script>


export default {
  name: 'ContactForm',
  components: {
    // HelloWorld
  },
  data() {
    return{
      discount: false,
      discountAmount: 0,
      contact: {
        lastName:'',
        firstName:'',
        email:'',
        street:'',
        zip:'',
        city:'',
        phone:'',
        message:'',
        voucher:'',
        country:'Deutschland',
        shipping:true,
        datasecurity: false,
        outsideGermany: false,
        expressBuild: "expressBuildNo",
      },
      shippingVmodel:'shipping',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'Bitte eine gültige E-mail Adresse eingeben',
      ],
    }
   },
   computed: {
     getText(){ return this.$store.getters.getText.cart.contactForm },
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getCustomerInformation(){ return this.$store.getters.getCustomerInformation; },
     getVoucherAccepted(){ return this.$store.getters.getVoucher.voucherAccepted; },
     getOrder(){ return this.$store.getters.getOrder},
     getShippingCost() {return this.$store.getters.getShippingCost},
     shippingLabel(){ return this.getText.pickUp + this.getShippingCost + ")"},
     getExpressBuild(){return this.$store.getters.getExpressBuild}
   },
   methods: {
     applyVoucher(){
       this.$store.dispatch("applyVoucher");
     },
     checkDiscount(){
       for (var product in this.getOrder.products){
         if(this.getOrder.products[product].discount){
           this.discountAmount += this.getOrder.products[product].discountAmount
           this.discount = true
         }
       }
     }
   },
   mounted () {
     this.contact = this.getCustomerInformation
     this.checkDiscount()
   },
   watch:{
     shippingVmodel: function(){
       if (this.shippingVmodel == "pickUp"){
         this.contact.shipping = false
       } else {
         this.contact.shipping = true
       }
       if (this.shippingVmodel == "outsideGermany"){
         this.contact.outsideGermany = true
       } else {
         this.contact.outsideGermany = false
       }
     },
     contact: function(){
       this.$store.dispatch("changeCustomerInformation", this.contact);
     },

     'contact.shipping': function (){
       this.$store.dispatch("changeCustomerInformation", this.contact);
     },
     'contact.expressBuild': function (){
       this.$store.dispatch("changeCustomerInformation", this.contact);
     },
   }
}
</script>

<style scoped>
  input{
    border: none;
    border-bottom: solid 1px var(--mainColor);

  }
  .ContactForm{
    padding: 0 100px;
    margin: 0;
    max-width: 550px;
    width: 100%;
    position: relative;
  }
  .ContactFormMobile{
    margin: 0;
    max-width: 550px;
    width: 100%;
    position: relative;
  }
  .card{
    padding: 8px 10px;
    margin: 15px 0;
  }


</style>
